export const routes = {
  home: "/",
  accountDeleted: "/account-deleted",
  deleteAccountConfirmation: "/delete-account-confirmation",
  deleteAccountError: "/delete-account-error",
  savedProjects: "/saved-projects",
  orders: "/orders",
  orderDetails: "/orders/:orderCode",
  settings: "/settings",
  personalDetails: "/settings/personal-details",
  changeEmail: "/settings/email",
  changeEmailConfirmation: "/change-email-confirmation",
  changeEmailSuccess: "/change-email-success",
  changeEmailError: "/change-email-error"
};
